import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import getUserId from '../../functions/getUserId';
import fetchAlertRelatedTrendsearchData from '../../functions/fetch_alert_related_trendsearch_data';

export const getAlertRelatedTrendsearchData = createAsyncThunk(
  'trendsearch_data/getAlertRelatedTrendsearchData',
  async (token) => {
    const userId = getUserId();
    const data = await fetchAlertRelatedTrendsearchData(userId, token);
    return data;
  }
);

const trendsearchSlice = createSlice({
  name: 'trendsearch_data',
  initialState: {
    alert_related_trendsearch_data: null,
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAlertRelatedTrendsearchData.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getAlertRelatedTrendsearchData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        // API returns { success, data, ... }
        state.alert_related_trendsearch_data = action.payload?.data || [];
      })
      .addCase(getAlertRelatedTrendsearchData.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default trendsearchSlice.reducer;
// getAlertRelatedTrendsearchData is already exported above via named export


